export enum BillTypeEnum {
  OPERATIONAL_COST = 'CUSTO OPERACIONAL',
  EXTRA_INVOICE = 'FATURA EXTRA',
  CARNET_COMPLEMENT = 'CARNET COMPLEMENTAR-COPARTICIPACAO',
  HEALTH_PLAN_MONTHLY_FEE = 'MENSALIDADE PLANO SAUDE',
}
